module.exports = __webpack_public_path__ + "assets/teethUpper.a6d712b708f41e5388c3702e37aa60fc.png";